module.exports = __webpack_public_path__ + "a6afbf9a6d68ab7f4956fe8a4d31ed26.png";